module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e88aa1914f6e26f67ed981ecc1cd8f1a.png";